import AppHeader from "../../component/modules/appHeader/AppHeader";
import Footer from "../../component/modules/footer/Footer";
import HeroSection from "../../component/modules/heroSection/HeroSection";
import PortfolioSection from "../../component/modules/portfolioSection/PortfolioSection";
import { PORTFOLIO_SECTION } from "../../utility/utilityData";
import "./index.css";

const Portfolio = () => {
  return (
    <div className="portfolio_page_container">
      <AppHeader />
      <div className="portfolio_content_container">
        <HeroSection
          headingpart1="Our"
          headingpart2="Portfolio"
          description=" Discover how we've helped businesses across various industries achieve their digital transformation goals."
        />
        <PortfolioSection
          sectionHeading={PORTFOLIO_SECTION?.sectionHeading || ""}
          headingPart1={PORTFOLIO_SECTION?.headingPart1 || ""}
          headingPart2={PORTFOLIO_SECTION?.headingPart2 || ""}
          description={PORTFOLIO_SECTION?.description}
          portfolio={PORTFOLIO_SECTION?.portfolio}
        />
      </div>
      <Footer />
    </div>
  );
};

export default Portfolio;
